import { VButton } from '../VButton';
import { VChip } from '../VChip';
import { VFlex } from '../VFlex';
import { VStack } from '../VStack';
import { usePickListContext } from './hook';
import style from './style';
import type { BaseItem } from './type';

type VPickedItemListProps = {
  pickedItemListTitle?: string;
  confirmButtonText?: string;
  onConfirm?: (items: BaseItem[]) => void;
};

const VPickedItemList = ({
  pickedItemListTitle,
  confirmButtonText,
  onConfirm,
}: VPickedItemListProps) => {
  const { innerPickedItems, maxListHeight, toggleItem } = usePickListContext();

  const onClick = () => {
    onConfirm?.(innerPickedItems);
  };

  return (
    <VStack
      className={style.pickedItemListContainer}
      style={{
        maxHeight: maxListHeight != null ? `${maxListHeight}px` : 'none',
      }}
      gap={1}
    >
      <VStack className={style.pickedItemList} gap={1}>
        <div className={style.pickedItemListTitle}>
          {pickedItemListTitle || 'Picked Items'}
        </div>

        <div className={style.pickedItemContentsWrapper}>
          <VFlex className={style.pickedItemContents}>
            {innerPickedItems.map(item => {
              return (
                <VChip key={item.value} onDelete={() => toggleItem(item)}>
                  {item.value}
                </VChip>
              );
            })}
          </VFlex>
        </div>
      </VStack>

      <VButton size="md" onClick={onClick}>
        {confirmButtonText || '+'}
      </VButton>
    </VStack>
  );
};

export default VPickedItemList;
